import { schema } from "normalizr";

const DepartmentSchema = new schema.Entity("departments");
const DepartmentArraySchema = new schema.Array(DepartmentSchema);

export { DepartmentSchema, DepartmentArraySchema };